var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as TYPES from "./types";
import * as gamService from '../../services/gam-service';
import { multiAction } from '../../utils/ReduxUtil';
export var networkInit = function () { return ({ type: TYPES.GET_NETWORK_INIT }); };
export var networkSuccess = function (data) { return ({ type: TYPES.GET_NETWORK_SUCCESS, data: data }); };
export var networkError = function (error) { return ({ type: TYPES.GET_NETWORK_ERROR, error: error }); };
export var networkDone = function () { return ({ type: TYPES.GET_NETWORK_DONE }); };
export var getNetwork = function (param) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var result, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(networkInit());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, gamService.getListNetworks(param)];
                case 2:
                    result = _a.sent();
                    dispatch(multiAction([networkSuccess(result), networkDone()]));
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    dispatch(multiAction([networkError(err_1), networkDone()]));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var lineItemInit = function () { return ({ type: TYPES.GET_LINE_ITEM_INIT }); };
export var lineItemSuccess = function (data) { return ({ type: TYPES.GET_LINE_ITEM_SUCCESS, data: data }); };
export var lineItemError = function (error) { return ({ type: TYPES.GET_LINE_ITEM_ERROR, error: error }); };
export var lineItemDone = function () { return ({ type: TYPES.GET_LINE_ITEM_DONE }); };
export var getLineItems = function (param) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var result, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(lineItemInit());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, gamService.getLineItems(param)];
                case 2:
                    result = _a.sent();
                    dispatch(multiAction([lineItemSuccess(result), lineItemDone()]));
                    return [3 /*break*/, 4];
                case 3:
                    err_2 = _a.sent();
                    dispatch(multiAction([lineItemError(err_2), lineItemDone()]));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var resetNetworkInfo = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(networkSuccess(null));
            dispatch(networkError(null));
            return [2 /*return*/];
        });
    }); };
};
export var resetLineItemsInfo = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(lineItemSuccess(null));
            dispatch(lineItemError(null));
            return [2 /*return*/];
        });
    }); };
};
